import { ExecutorEntity, PipelineStep } from '@telespot/domain';
import { ParseMapper } from '../../parse.mapper';
import { PipelineTopology } from './parse-pipeline.mapper';
import { AlgorithmTopology } from '../ai';
import { SoftDeletableTopology } from '../../parse.topology';

export enum PipelineStepTopology {
  TABLE = 'PipelineStep',
  ORDER = 'order',
  EXECUTOR = 'executor',
  PIPELINE = 'pipeline',
  TRIGGER = 'trigger',
  GENERATEFINDING = 'generateFinding',
  TASK = 'task',
  PARAMS = 'params',
}

export class ParsePipelineStepMapper extends ParseMapper {
  public toDomain(parseObject: Parse.Object<Parse.Attributes>): PipelineStep {
    return new PipelineStep({
      id: parseObject.id,
      order: parseObject.get(PipelineStepTopology.ORDER),
      executorId: parseObject.get(PipelineStepTopology.EXECUTOR)?.id,
      executorEntity: parseObject.get(PipelineStepTopology.EXECUTOR) ? ExecutorEntity.ALGORITHM : ExecutorEntity.USER,
      pipelineId: parseObject.get(PipelineStepTopology.PIPELINE)?.id,
      trigger: parseObject.get(PipelineStepTopology.TRIGGER),
      generateFinding: parseObject.get(PipelineStepTopology.GENERATEFINDING),
      task: parseObject.get(PipelineStepTopology.TASK),
      params: parseObject.get(PipelineStepTopology.PARAMS),
      deletedAt: parseObject.get(SoftDeletableTopology.DELETED_AT),
    });
  }

  public fromDomain(step: PipelineStep): Parse.Object<Parse.Attributes> {
    const ParsePipelineStep = this.subclasses.getSubclass(PipelineStepTopology.TABLE);
    const ParsePipeline = this.subclasses.getSubclass(PipelineTopology.TABLE);
    const ParseAlgorithm = this.subclasses.getSubclass(AlgorithmTopology.TABLE);

    const parseObject = step.id ? ParsePipelineStep.createWithoutData(step.id) : new ParsePipelineStep();

    parseObject.set(PipelineStepTopology.ORDER, step.order);
    parseObject.set(PipelineStepTopology.PIPELINE, ParsePipeline.createWithoutData(step.pipelineId));
    parseObject.set(PipelineStepTopology.TRIGGER, step.trigger);
    parseObject.set(PipelineStepTopology.GENERATEFINDING, step.generateFinding);
    parseObject.set(PipelineStepTopology.TASK, step.task);
    parseObject.set(PipelineStepTopology.PARAMS, step.params);

    // Set or unset the executor
    const parseCreatedBy =
      step.executorEntity === ExecutorEntity.USER ? undefined : ParseAlgorithm.createWithoutData(step.executorId);
    if (parseCreatedBy) {
      parseObject.set(PipelineStepTopology.EXECUTOR, parseCreatedBy);
    } else {
      parseObject.unset(PipelineStepTopology.EXECUTOR);
    }

    return parseObject;
  }
}
